export var HousingType;
(function (HousingType) {
    HousingType["CONDOMINIUM"] = "condominium";
    HousingType["COTTAGE"] = "cottage";
    HousingType["HOUSE"] = "house";
})(HousingType || (HousingType = {}));
export var PrivateLoanType;
(function (PrivateLoanType) {
    PrivateLoanType["STUDENT_LOAN"] = "STUDENT_LOAN";
    PrivateLoanType["ACCOUNT_CREDIT"] = "ACCOUNT_CREDIT";
    PrivateLoanType["INSTALMENT_CREDIT"] = "INSTALMENT_CREDIT";
    PrivateLoanType["UNSECURED_LOAN"] = "UNSECURED_LOAN";
})(PrivateLoanType || (PrivateLoanType = {}));
